const allCities = [
  {
    name: "Aventura",
    route: "/aventura",
    tagline: "Miami-Dade County expedited passport services",
    highlights: ["Aventura Mall area coverage", "Serving Sunny Isles, North Miami Beach"],
  },
  {
    name: "Boca Raton",
    route: "/boca-raton",
    tagline: "South Florida's premier passport courier service",
    highlights: ["Palm Beach County coverage", "Serving Delray Beach, West Palm"],
  },
  {
    name: "Bonita Springs",
    route: "/bonita-springs",
    tagline: "Southwest Florida expedited passport processing",
    highlights: ["Lee & Collier County coverage", "Serving Estero, Naples"],
  },
  {
    name: "Boynton Beach",
    route: "/boynton-beach",
    tagline: "Palm Beach County passport courier service",
    highlights: ["Boynton Beach area coverage", "Serving Delray Beach, Lake Worth"],
  },
  {
    name: "Cape Coral",
    route: "/cape-coral",
    tagline: "Lee County expedited passport services",
    highlights: ["Cape Coral area coverage", "Serving Fort Myers, Pine Island"],
  },
  {
    name: "Cedar Key",
    route: "/cedar-key",
    tagline: "Levy County expedited passport services on Florida's Nature Coast",
    highlights: ["Big Bend & Nature Coast coverage", "Serving Chiefland, Bronson, Williston, Crystal River"],
  },
  {
    name: "Celebration",
    route: "/celebration",
    tagline: "Osceola County trusted passport processing",
    highlights: ["Disney area coverage", "Serving Kissimmee, Davenport"],
  },
  {
    name: "Clearwater",
    route: "/clearwater",
    tagline: "Pinellas County expedited passport hub",
    highlights: ["Clearwater Beach area", "Serving Dunedin, Safety Harbor"],
  },
  {
    name: "Coral Gables",
    route: "/coral-gables",
    tagline: "Miami-Dade premium passport services",
    highlights: ["Coral Gables area coverage", "Serving Coconut Grove, Pinecrest"],
  },
  {
    name: "Coral Springs",
    route: "/coral-springs",
    tagline: "Broward County expedited passport processing",
    highlights: ["Coral Springs area coverage", "Serving Parkland, Margate"],
  },
  {
    name: "Deerfield Beach",
    route: "/deerfield-beach",
    tagline: "Broward County coastal passport services",
    highlights: ["Deerfield Beach area", "Serving Boca Raton, Pompano Beach"],
  },
  {
    name: "Delray Beach",
    route: "/delray",
    tagline: "Palm Beach County expedited passports",
    highlights: ["Atlantic Avenue area", "Serving Boynton Beach, Boca Raton"],
  },
  {
    name: "Dunedin",
    route: "/dunedin",
    tagline: "Pinellas County passport processing",
    highlights: ["Dunedin area coverage", "Serving Clearwater, Palm Harbor"],
  },
  {
    name: "Estero",
    route: "/estero",
    tagline: "Lee County expedited passport services",
    highlights: ["Estero area coverage", "Serving Bonita Springs, Fort Myers"],
  },
  {
    name: "Fort Lauderdale",
    route: "/fort-lauderdale",
    tagline: "Broward County expedited passport processing",
    highlights: ["Las Olas, Port Everglades area", "Serving cruise passengers, yacht crews"],
  },
  {
    name: "Fort Myers",
    route: "/fort-myers",
    tagline: "Southwest Florida passport courier service",
    highlights: ["Lee County coverage", "Serving Cape Coral, Bonita Springs"],
  },
  {
    name: "Gainesville",
    route: "/gainesville",
    tagline: "North Central Florida passport services",
    highlights: ["University of Florida area", "Serving Ocala, Lake City"],
  },
  {
    name: "Hollywood",
    route: "/hollywood",
    tagline: "Broward County expedited passport processing",
    highlights: ["Hollywood Beach area", "Serving Fort Lauderdale, Pembroke Pines"],
  },
  {
    name: "Islamorada",
    route: "/islamorada",
    tagline: "Florida Keys expedited passport services",
    highlights: ["Village of Islands coverage", "Serving Key Largo, Marathon"],
  },
  {
    name: "Jacksonville",
    route: "/jacksonville",
    tagline: "Northeast Florida's expedited passport hub",
    highlights: ["Duval County coverage", "Serving St. Augustine, Fernandina"],
  },
  {
    name: "Jensen Beach",
    route: "/jensen-beach",
    tagline: "Martin County expedited passport services",
    highlights: ["Jensen Beach area", "Serving Stuart, Port St. Lucie"],
  },
  {
    name: "Jupiter",
    route: "/jupiter",
    tagline: "Palm Beach County northern passport hub",
    highlights: ["Jupiter area coverage", "Serving Palm Beach Gardens, Tequesta"],
  },
  {
    name: "Key Largo",
    route: "/key-largo",
    tagline: "Upper Florida Keys expedited passports",
    highlights: ["Diving Capital of the World", "Serving Islamorada, Tavernier"],
  },
  {
    name: "Key West",
    route: "/key-west",
    tagline: "The Florida Keys' expedited passport solution",
    highlights: ["Island coverage", "Serving Marathon, Stock Island"],
  },
  {
    name: "Lake Mary",
    route: "/lake-mary",
    tagline: "Seminole County expedited passport services",
    highlights: ["Lake Mary area coverage", "Serving Sanford, Longwood"],
  },
  {
    name: "Lakewood Ranch",
    route: "/lakewood-ranch",
    tagline: "Manatee & Sarasota County passport services",
    highlights: ["Lakewood Ranch area", "Serving Bradenton, Sarasota"],
  },
  {
    name: "Marco Island",
    route: "/marco-island",
    tagline: "Collier County island passport services",
    highlights: ["Marco Island area", "Serving Naples, Everglades City"],
  },
  {
    name: "Melbourne",
    route: "/melbourne",
    tagline: "Space Coast expedited passport services",
    highlights: ["Brevard County coverage", "Serving Palm Bay, Cocoa Beach, Viera"],
  },
  {
    name: "Miami",
    route: "/miami",
    tagline: "Miami-Dade County emergency passport services",
    highlights: ["24-hour processing available", "International travel hub"],
  },
  {
    name: "Naples",
    route: "/naples",
    tagline: "Collier County luxury passport services",
    highlights: ["Naples area coverage", "Serving Bonita Springs, Marco Island"],
  },
  {
    name: "Orlando",
    route: "/orlando",
    tagline: "Central Florida's trusted expedited passport hub",
    highlights: ["24-hour emergency service", "Serving Winter Park, Kissimmee, Sanford"],
    badge: "Most Popular",
  },
  {
    name: "Palm Beach",
    route: "/palm-beach",
    tagline: "Palm Beach Island expedited passports",
    highlights: ["Palm Beach area coverage", "Serving West Palm Beach, Lake Worth"],
  },
  {
    name: "Palm Beach Gardens",
    route: "/palm-beach-gardens",
    tagline: "Northern Palm Beach County passport services",
    highlights: ["Palm Beach Gardens area", "Serving Jupiter, North Palm Beach"],
  },
  {
    name: "Palm Harbor",
    route: "/palm-harbor",
    tagline: "Pinellas County expedited passport processing",
    highlights: ["Palm Harbor area coverage", "Serving Dunedin, Tarpon Springs"],
  },
  {
    name: "Panama City",
    route: "/panama-city",
    tagline: "Emerald Coast travelers rely on our speed",
    highlights: ["Panhandle coverage", "Serving Destin, Fort Walton Beach"],
  },
  {
    name: "Parkland",
    route: "/parkland",
    tagline: "Broward County premium passport services",
    highlights: ["Parkland area coverage", "Serving Coral Springs, Coconut Creek"],
  },
  {
    name: "Pembroke Pines",
    route: "/pembroke-pines",
    tagline: "Broward County expedited passport processing",
    highlights: ["Pembroke Pines area", "Serving Hollywood, Miramar"],
  },
  {
    name: "Pensacola",
    route: "/pensacola",
    tagline: "Western Panhandle expedited passport services",
    highlights: ["Escambia County coverage", "Serving Gulf Breeze, Pace, Navarre"],
  },
  {
    name: "Plantation",
    route: "/plantation",
    tagline: "Broward County expedited passport services",
    highlights: ["Plantation area coverage", "Serving Fort Lauderdale, Sunrise"],
  },
  {
    name: "Ponte Vedra Beach",
    route: "/ponte-vedra-beach",
    tagline: "St. Johns County luxury passport services",
    highlights: ["Ponte Vedra Beach area", "Serving Jacksonville Beach, St. Augustine"],
  },
  {
    name: "Port St. Lucie",
    route: "/port-st-lucie",
    tagline: "Treasure Coast expedited passport hub",
    highlights: ["Port St. Lucie area", "Serving Stuart, Jensen Beach"],
  },
  {
    name: "Quincy",
    route: "/quincy",
    tagline: "Gadsden County expedited passport services",
    highlights: ["Historic Quincy area", "Serving Havana, Chattahoochee, Gadsden County"],
  },
  {
    name: "Riverview",
    route: "/riverview",
    tagline: "Hillsborough County passport processing",
    highlights: ["Riverview area coverage", "Serving Brandon, Apollo Beach"],
  },
  {
    name: "Safety Harbor",
    route: "/safety-harbor",
    tagline: "Pinellas County expedited passport services",
    highlights: ["Safety Harbor area", "Serving Clearwater, Dunedin"],
  },
  {
    name: "Sarasota",
    route: "/sarasota",
    tagline: "Florida's Cultural Coast expedited passport service",
    highlights: ["Sarasota-Bradenton area coverage", "Serving Ringling College, Venice, Bradenton"],
  },
  {
    name: "St. Petersburg",
    route: "/st-petersburg",
    tagline: "Tampa Bay area expedited passports",
    highlights: ["Pinellas County coverage", "Near Clearwater, Largo"],
  },
  {
    name: "Stuart",
    route: "/stuart",
    tagline: "Martin County expedited passport services",
    highlights: ["Stuart area coverage", "Serving Jensen Beach, Palm City"],
  },
  {
    name: "Sunny Isles",
    route: "/sunny-isles",
    tagline: "Miami-Dade coastal passport services",
    highlights: ["Sunny Isles Beach area", "Serving Aventura, North Miami Beach"],
  },
  {
    name: "Tallahassee",
    route: "/tallahassee",
    tagline: "North Florida capital city expedited passport services",
    highlights: ["Leon County coverage", "Serving Monticello, Crawfordville, Quincy"],
  },
  {
    name: "Tampa",
    route: "/tampa",
    tagline: "Fast passport processing for the Gulf Coast",
    highlights: ["Same-day options available", "Serving St. Petersburg, Clearwater"],
  },
  {
    name: "Upper Grand Lagoon",
    route: "/upper-grand-lagoon",
    tagline: "Bay County expedited passport services on St. Andrews Bay",
    highlights: ["St. Andrews Bay area coverage", "Serving Panama City Beach, Panama City, Lynn Haven"],
  },
  {
    name: "Venice",
    route: "/venice",
    tagline: "Sarasota County expedited passport services",
    highlights: ["Venice area coverage", "Serving Sarasota, North Port"],
  },
  {
    name: "Wellington",
    route: "/wellington",
    tagline: "Palm Beach County equestrian country passport services",
    highlights: ["Wellington area coverage", "Serving West Palm Beach, Loxahatchee"],
  },
  {
    name: "Wesley Chapel",
    route: "/wesley-chapel",
    tagline: "Pasco County expedited passport processing",
    highlights: ["Wesley Chapel area", "Serving Land O' Lakes, Zephyrhills"],
  },
  {
    name: "Weston",
    route: "/weston",
    tagline: "Broward County premium passport services",
    highlights: ["Weston area coverage", "Serving Fort Lauderdale, Pembroke Pines"],
  },
  {
    name: "West Palm Beach",
    route: "/west-palm-beach",
    tagline: "Palm Beach County expedited passports",
    highlights: ["Downtown WPB area", "Serving Palm Beach, Wellington, Jupiter"],
  },
  {
    name: "Windermere",
    route: "/windermere",
    tagline: "Orange County luxury passport services",
    highlights: ["Windermere area coverage", "Serving Winter Garden, Ocoee"],
  },
  {
    name: "Winter Garden",
    route: "/winter-garden",
    tagline: "Orange County expedited passport processing",
    highlights: ["Winter Garden area", "Serving Windermere, Ocoee"],
  },
  {
    name: "Winter Park",
    route: "/winter-park",
    tagline: "Orange County premier passport services",
    highlights: ["Winter Park area coverage", "Serving Orlando, Maitland"],
  },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function FloridaCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Florida Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Florida Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) => (
              <a
                key={i}
                href={city.route}
                className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
              >
                {city.badge && (
                  <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                    {city.badge}
                  </span>
                )}
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                    <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                    <p className="text-gray-400 text-xs">Florida</p>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                <ul className="space-y-2 mb-6 flex-1">
                  {city.highlights.map((h, j) => (
                    <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                      <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                      {h}
                    </li>
                  ))}
                </ul>
                <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                  View Services{" "}
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                </div>
              </a>
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Florida locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}